import { StreamElement } from '../../modules/StoryEdit';
import { Category } from '../Entities/Categories/categories.reducer';
import actionCreatorFactory from 'typescript-fsa';
import {
  Row,
  SourceCategory,
  Story,
  TargetCategory,
  AppConfig,
} from '../Entities/Stories/stories.reducer';
import { InitialStory } from '../../modules/StoryCreate/index';
import { Country } from '../../utils/country';
const actionCreator = actionCreatorFactory('StreamEdit');

export const setActualStory = actionCreator<{ storyId: Number }>(
  'STREAM_EDIT_SET_ACTUAL_STORY'
);
export const editStoryFetched = actionCreator<{
  story: Story;
  appConfigs: any;
  cluster?: any;
}>('STREAM_EDIT_EDIT_STORY_FETCHED');

export const updateStreamCategories = actionCreator<{}>(
  'STREAM_EDIT_UPDATE_STREAM_CATEGORIES'
);

export const rehydrateStreamCategory = actionCreator<{
  sourceCategory: SourceCategory;
}>('STREAM_EDIT_REHYDRATE');

export const copyStreamCategories = actionCreator<{
  appId: number;
  categories: SourceCategory[];
}>('STREAM_EDIT_COPY_STREAM_CATEGORIES');

export const addSourceCategoryForAppId = actionCreator<{
  appId: number;
  categories: SourceCategory[];
}>('STREAM_EDIT_UPDATE_STREAM_CATEGORY');

export interface SetStoryEditDatesPayload {
  active_from?: string;
  active_to?: string;
  boost_from?: string;
  boost_to?: string;
  rebrushed_at?: string;
}

export const setStoryEditDates = actionCreator<SetStoryEditDatesPayload>(
  'VISIBILITY_UPDATE'
);

export const updateStoryEditActiveDates = actionCreator<{
  appId: number;
  active_from: string | null;
  active_to?: string | null;
}>('ACTIVE_DATES_UPDATE');

export const updateStoryEditRebrushedAt = actionCreator<{
  appId: number;
  rebrushed_at: string | null;
}>('REBRUSHED_AT_UPDATE');

export const updateStoryEditBoostDates = actionCreator<{
  appId: number;
  boost_from: string | null;
  boost_to: string | null;
}>('BOOST_DATES_UPDATE');

export const addStoryEditTargetCategory = actionCreator<{
  category: Category;
}>('TARGET_CATEGORY_ADD');

export const removeStoryEditTargetCategory = actionCreator<{
  targetCategory: TargetCategory;
}>('TARGET_CATEGORY_REMOVE');

export const saveStory = actionCreator('STREAM_EDIT_SAVE_STORY');

export const updateStoryEditTargetCategories = actionCreator<{
  appId: number;
  targetCategories: TargetCategory[];
}>('TARGET_CATEGORIES_UPDATE');

export const startLoading = actionCreator('STREAM_EDIT_LOADING_START');
export const stopLoading = actionCreator('STREAM_EDIT_LOADING_END');

export const deleteSourceCategory = actionCreator<{
  sourceCategoryId: number;
}>('STREAM_EDIT_DELETE_SOURCE_CATEGORY');

export const updateStoryEditSourceCategories = actionCreator<{
  appId: number;
  sourceCategories: SourceCategory[];
}>('SOURCE_CATEGORIES_UPDATE');

export const addAppConfig = actionCreator<AppConfig>(
  'STREAM_EDIT_ADD_APP_CONFIG'
);

export const updateStoryEditActiveAppId = actionCreator<{ appId: number }>(
  'STORY_EDIT_UPDATE_ACTIVE_APP_ID'
);

export const updateStoryEditSettings = actionCreator<InitialStory>(
  'STORY_EDIT_UPDATE_SETTINGS'
);

export const changeCountry = actionCreator<{ country: Country }>(
  'COUNTRY_CHANGE'
);

export const updateHeadlinesByLanguagegroupForAppId = actionCreator<{
  appId: number;
}>('UPDATE_HEADLINES_BY_GROUP');

export const saveElementRow = actionCreator<Row[]>('ELEMENT_ROW_SAVE');
export const updateElementRow = actionCreator<Row[]>('ELEMENT_ROW_UPDATE');
export const saveTeaser = actionCreator<StreamElement>('ELEMENT_TEASER_SAVE');
export const saveTeaserVideo = actionCreator<StreamElement>(
  'ELEMENT_TEASER_VIDEO_SAVE'
);
export const updateTeaser = actionCreator<Story>('ELEMENT_TEASER_UPDATE');
export const updateTeaserVideo = actionCreator<Story>(
  'ELEMENT_TEASER_VIDEO_UPDATE'
);

export const resetActiveStory = actionCreator('RESET_ACTIVE_STORY');

export const addProducts = actionCreator<{
  appId: number;
  productIds: number[];
}>('PRODUCT_ADD');
export const addOutfits = actionCreator<{ appId: number; outfitIds: number[] }>(
  'OUTFIT_ADD'
);

export const copyDates = actionCreator<{
  sourceAppId: number;
  targetAppId: number;
}>('COPY_DATES');

export const copyTargetCategories = actionCreator<{
  sourceAppId: number;
  targetAppId: number;
}>('COPY_TARGET_CATEGORIES');

export const copyBoostedProducts = actionCreator<{
  sourceAppId: number;
  targetAppId: number;
}>('COPY_BOOSTED_PRODUCTS');

export interface NewOutfitForAppIdPayload {
  appId: number;
  outfitId: number;
  dontSave?: boolean;
  appIds?: number[];
}

export const newOutfitForAppId = actionCreator<NewOutfitForAppIdPayload>(
  'NEW_OUTFIT_FOR_APP'
);

export interface NewProductForAppIdPayload {
  appId: number;
  productId: number;
  dontSave?: boolean;
}

export const newProductForAppId = actionCreator<NewProductForAppIdPayload>(
  'NEW_PRODUCT_FOR_APP'
);

export const updateProductIdsForAppId = actionCreator<{
  appId: number;
  productIds: number[];
}>('UPDATE_PRODUCT_IDS');

export const changeResourceTypeAndResourceId = actionCreator<{
  storyId: number;
  resourceType: string;
}>('CHANGE_RESOURCE_TYPE_AND_RESOURCE_ID');

export interface DeleteProductForAppIdPayload {
  appId: number;
  productId: number;
}

export const deleteProductForAppId = actionCreator<
  DeleteProductForAppIdPayload
>('DELETE_PRODUCT_FOR_APP_ID');

export interface DeleteOutfitForAppIdPayload {
  appId: number;
  outfitId: number;
}

export const deleteOutfitForAppId = actionCreator<DeleteOutfitForAppIdPayload>(
  'DELETE_OUTFIT_FOR_APP_ID'
);

export const removeProductIdForAppConfig = actionCreator<{
  appId: number;
  productId: number;
}>('REMOVE_PRODUCT_ID_FOR_APPCONFIG');

export const removeOutfitIdForAppConfig = actionCreator<{
  appId: number;
  outfitId: number;
}>('REMOVE_OUTFIT_ID_FOR_APPCONFIG');

export const updateTargetCategoryIsPinned = actionCreator<{
  appId: number;
  targetCategoryId: number;
  isPinned: boolean;
}>('UPDATE_TARGET_CATEGORY_PINNED');

export const updateStreamProductCount = actionCreator<{
  appId: number;
  count: number;
}>('ADD_STREAM_PRODUCT_COUNT');

export const resetStoryEdit = actionCreator('RESET');

export const unpublishStoryAppConfig = actionCreator<{ appId: number }>(
  'UNPUBLISH_STORY_EDIT'
);



// WEBPACK FOOTER //
// ./src/store/StoryEdit/story-edit.actions.ts